import { isRequiredStringValid } from "./isRequiredStringValid";

interface FormatErrors {
  required: string;
  invalidFormat: string;
}

/** Validates the format of a number range (e.g. CreditNumberRange or InvoiceNumberRange).
 * The format must be a string and pass the supplied isFormatValid function.
 * Invalid formats will received the corresponding error message from formatErrors.
 */
export function validateNumberRangeFormat(
  value: string | null | undefined,
  isFormatValid: (format: string | null) => boolean,
  formatErrors: FormatErrors
) {
  if (!isRequiredStringValid(value)) {
    return formatErrors.required;
  }

  if (!isFormatValid(value)) {
    return formatErrors.invalidFormat;
  }

  return "";
}
